import apiInstance from '@/axios';

export const getConnectorDashboard = async (page = 1, limit = 50, search = '') => {
    const response = await apiInstance.get('/companies/emr-tunnel/dashboard', {
        params: { page, limit, search },
    });
    return response.data;
};

export const getConnectorNotices = async (page = 1, limit = 20) => {
    const response = await apiInstance.get('/companies/emr-tunnel/notices', {
        params: { page, limit },
    });
    return response.data;
};

export const createConnectorNotice = async (data) => {
    const response = await apiInstance.post('/companies/emr-tunnel/notices', data);
    return response.data;
};

export const updateConnectorNotice = async (id, data) => {
    const response = await apiInstance.put(`/companies/emr-tunnel/notices/${id}`, data);
    return response.data;
};

export const deleteConnectorNotice = async (id) => {
    const response = await apiInstance.delete(`/companies/emr-tunnel/notices/${id}`);
    return response.data;
};
